module.exports = __webpack_public_path__ + "img/26.8817b742.jpg";